/**
 * Image thumbnail component for chat attachments
 * Displays a preview image with remove button
 */

import React from 'react';
import { css } from '@emotion/react';
import { colors } from '../../../styles';

export interface AttachedImage {
  id: string;
  dataUrl: string;
  fileName: string;
  mimeType?: string;
  sizeBytes?: number;
}

interface ImageThumbnailProps {
  image: AttachedImage;
  onRemove: () => void;
}

const ImageThumbnail: React.FC<ImageThumbnailProps> = ({ image, onRemove }) => {
  return (
    <div css={containerStyle}>
      <img src={image.dataUrl} alt={image.fileName} css={imageStyle} />
      <button css={removeButtonStyle} onClick={onRemove} aria-label={`Remove ${image.fileName}`} type="button">
        ✕
      </button>
    </div>
  );
};

const containerStyle = css`
  position: relative;
  width: 80px;
  height: 80px;
  flex-shrink: 0;
`;

const imageStyle = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid ${colors.cloud};
`;

const removeButtonStyle = css`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: ${colors.berry};
  color: ${colors.snow};
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
  padding: 0;
  line-height: 1;

  &:hover {
    background: ${colors.orange};
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }
`;

export default ImageThumbnail;
